module.exports = "/_next/static/images/e8aadf787ac98939d147d99cb2de89d3-four-cards-full.svg";